'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _components = require('components');

var _reactI18next = require('react-i18next');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coverCenteredImg = require('./cover-style-centered.png');
var coverFullImg = require('./cover-style-full.png');

var CoverStyle = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    project: state.project.projectData || {},
    updateCoverStyleLoading: state.project.updateCoverStyleLoading,
    updateCoverStyleActionData: state.project.updateCoverStyleActionData
  };
}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CoverStyle, _Component);

  function CoverStyle() {
    (0, _classCallCheck3.default)(this, CoverStyle);
    return (0, _possibleConstructorReturn3.default)(this, (CoverStyle.__proto__ || (0, _getPrototypeOf2.default)(CoverStyle)).apply(this, arguments));
  }

  (0, _createClass3.default)(CoverStyle, [{
    key: 'updateCoverStyle',
    value: function updateCoverStyle(coverStyle) {
      var _props = this.props,
          project = _props.project,
          updateCoverStyle = _props.updateCoverStyle;

      return updateCoverStyle(project.id, coverStyle);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          project = _props2.project,
          updateCoverStyleLoading = _props2.updateCoverStyleLoading,
          coverStyle = _props2.updateCoverStyleActionData.coverStyle;


      var renderOption = function renderOption(val, image, title) {
        var isStyleActive = project.coverStyle === val;
        return _react2.default.createElement(
          'div',
          { className: 'col-xs-30 col-md-20 col-lg-15' },
          _react2.default.createElement(
            _components.Checkbox,
            {
              textAfter: title,
              checked: isStyleActive,
              disabled: updateCoverStyleLoading,
              onChange: function onChange() {
                return _this2.updateCoverStyle(val);
              }
            },
            _react2.default.createElement(
              'span',
              { className: 'pos-rel inline-block' },
              _react2.default.createElement('img', { src: image, className: 'max-width-100', alt: '' }),
              updateCoverStyleLoading && coverStyle === val && _react2.default.createElement(_components.Loader, { mask: true })
            ),
            _react2.default.createElement('br', null)
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        renderOption(0, coverCenteredImg, t('Centered')),
        renderOption(1, coverFullImg, t('Full width'))
      );
    }
  }]);
  return CoverStyle;
}(_react.Component), _class2.propTypes = {
  project: _propTypes2.default.object,
  t: _propTypes2.default.func,
  updateCoverStyle: _propTypes2.default.func,
  updateCoverStyleActionData: _propTypes2.default.object,
  updateCoverStyleLoading: _propTypes2.default.bool
}, _temp)) || _class) || _class);
exports.default = CoverStyle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/CoverStyle.js
// module id = 2084
// module chunks = 1